<template>
    <div>
        <el-row style="margin-bottom:10px;">
            <el-col :span="18" class='flex'>
                <!-- <el-input
          v-model="getPkqPaperList_data.qpName"
          placeholder="请输入试卷名称"
          clearable
          size='small'
          style="max-width:380px;"/> -->
                <el-select v-model="getPkqPaperList_data.qpStatus" clearable placeholder="状态" size="small"
                    style="max-width:150px;" @change="getList2">
                    <el-option label="已创建" :value="1"></el-option>
                    <el-option label="答题中" :value="2"></el-option>
                    <el-option label="已答题" :value="3"></el-option>
                    <el-option label="已过期" :value="4"></el-option>
                </el-select>
                <el-button v-click.getPkqPaperList type="primary" icon='el-icon-search' size='small'
                    style='margin-left:10px;'>搜索
                </el-button>
                <!-- <el-button @click="Bulksure()" type="success" icon="el-icon-search" size="small"
                    style="margin-left:10px;">导出
                </el-button> -->
            </el-col>
            <el-col :span="6">
            </el-col>
        </el-row>

        <mytable :tableColums='tableColums_getPkqPaperList' api='getPkqPaperList'
            updateapi='updateQuestionPaperRecordShowScore' :height="H - 165">
        </mytable>

        <myform width="80%" view.getPkqPaperDetails="详情"
            @close='$form("getPkqPaperDetails", "hide"), getPkqPaperList()'>
            <div style="width: 100%;display: flex;justify-content:space-around;overflow-y: auto;"
                v-if="topicArr.pkqPaperRecordOne">
                <div class="textclass" style="width: 50%;height: 60vh;padding: 50px 50px 15px;">
                    <div>姓名: {{ topicArr.pkqPaperRecordOne.createusername }}</div>
                    <div>得分:{{ topicArr.pkqPaperRecordOne.qprShowScore }}</div>
                    <div id="" v-for="(item, index) in topicArr.pkqPaperRecordOne.pkqPaperTopicList || []" :key="index">
                        <p style="margin: 15px 0;font-size: 16px;">{{ index
                            + 1 }}.({{ item.qttName }}){{ item.qtName }}</p>
                        <el-radio-group v-model="checkList1[index][0]" v-if="item.qttId != 2 && item.qttId != 4"
                            v-for="(topic, n) in item.pkqTopicItemList" :key="n" style="display:block;"
                            text-color="red">
                            <el-radio :label="topic.qtiId" style="margin: 5px;" size="medium" border
                                v-model="item.qptAnswerIds" disabled>{{
                                    topic.qtiValue }}</el-radio>
                        </el-radio-group>
                        <el-checkbox-group v-model="checkList1[index]" v-if="item.qttId == 2"
                            v-for="(topic, n) in item.pkqTopicItemList" :key="n">
                            <el-checkbox :label="topic.qtiId" style="margin: 5px;">{{ topic.qtiValue
                                }}</el-checkbox>
                        </el-checkbox-group>
                        <el-input style="width: 100%;margin-left:0px;" v-model="checkList[index][0]" placeholder="请输入答案"
                            v-if="item.qttId == 4"></el-input>
                        <div :style="{ 'color': item.qtScoreRight === 2 ? 'green' : 'red' }"
                            style="font-size: 18px;margin: 15px;">{{ item.qtScoreRight === 2 ? '正确' : '错误' }}</div>
                    </div>
                </div>
                <div class="textclass" style="width: 50%;height: 60vh;padding: 50px 50px 15px;">
                    <div>姓名: {{ topicArr.pkqPaperRecordTwo.createusername }}</div>
                    <div>得分:{{ topicArr.pkqPaperRecordTwo.qprShowScore }}</div>
                    <div id="" v-for="(item, index) in topicArr.pkqPaperRecordTwo.pkqPaperTopicList || []" :key="index">
                        <p style="margin: 15px 0;font-size: 16px;">{{ index
                            + 1 }}.({{ item.qttName }}){{ item.qtName }}</p>
                        <el-radio-group v-model="checkList2[index][0]" v-if="item.qttId != 2 && item.qttId != 4"
                            v-for="(topic, n) in item.pkqTopicItemList" :key="n" style="display:block;"
                            text-color="red">
                            <el-radio :label="topic.qtiId" style="margin: 5px;" size="medium" border
                                v-model="item.qptAnswerIds" disabled>{{
                                    topic.qtiValue }}</el-radio>
                        </el-radio-group>
                        <el-checkbox-group v-model="checkList2[index]" v-if="item.qttId == 2"
                            v-for="(topic, n) in item.pkqTopicItemList" :key="n">
                            <el-checkbox :label="topic.qtiId" style="margin: 5px;">{{ topic.qtiValue
                                }}</el-checkbox>
                        </el-checkbox-group>
                        <el-input style="width: 100%;margin-left:0px;" v-model="checkList[index][0]" placeholder="请输入答案"
                            v-if="item.qttId == 4"></el-input>
                        <div :style="{ 'color': item.qtScoreRight === 2 ? 'green' : 'red' }"
                            style="font-size: 18px;margin: 15px;">{{ item.qtScoreRight === 2 ? '正确' : '错误' }}</div>
                    </div>
                </div>
            </div>
            <hide slot='qpId' />
        </myform>

    </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
export default {
    data() {
        return {
            puId_arr: [],
            pdrId_arr: [],
            checkList1: [],
            checkList2: [],
            topicArr: [],
            attrId: null,
            baseUrl: $Api.baseUrl_online,
            row: {},
            rowTem: {},

            tableColums_getPkqPaperList: {
                $selection: false,
                qpName: '试卷名称',
                qpStatus: ['试卷总状态', , '@v-if: 1:已创建#danger, 2:答题中#danger,3:已答题#danger,4:已过期#info'],

                puGridOne: '用户1',

                qprShowScoreOne: '得分',

                qprTotalTimeOne: '答题时间',

                qpStatusOne: ['试卷状态', , '@v-if: 1:已创建#danger, 2:答题中#danger,3:已答题#danger,4:已过期#info'],

                puGridTwo: '用户2',

                qprShowScoreTwo: '得分',

                qprTotalTimeTwo: '答题时间',
                qpStatusTwo: ['试卷状态', , '@v-if: 1:已创建#danger, 2:答题中#danger,3:已答题#danger,4:已过期#info'],

                createtime: '创建时间',

                $operation: [
                    '操作', 100,
                    this.getPkqPaperDetails && `@text: 详情#success
           @click:DetailText($row)
          `,
                ],

            },
        };
    },

    watch: {

    },

    methods: {
        DetailText(row) {
            if (row.qpId) {
                this.getPkqPaperDetails({ qpId: row.qpId }).result(res => {
                    this.topicArr = res.data.data;
                    this.checkList1 = [];
                    this.checkList2 = [];
                    for (var i = 0; i < res.data.data.pkqPaperRecordOne.pkqPaperTopicList.length; i++) {
                        if (res.data.data.pkqPaperRecordOne.pkqPaperTopicList[i].qttId == 4) {
                            this.checkList1.push((res.data.data.pkqPaperRecordOne.pkqPaperTopicList[i].qptAnswerIds || ''))
                            console.log(res.data.data);
                        } else {
                            this.checkList1.push((res.data.data.pkqPaperRecordOne.pkqPaperTopicList[i].qptAnswerIds || '').split(',').map(Number))
                        }

                    }
                    for (var i = 0; i < res.data.data.pkqPaperRecordTwo.pkqPaperTopicList.length; i++) {
                        if (res.data.data.pkqPaperRecordTwo.pkqPaperTopicList[i].qttId == 4) {
                            this.checkList2.push((res.data.data.pkqPaperRecordTwo.pkqPaperTopicList[i].qptAnswerIds || ''))
                        } else {
                            this.checkList2.push((res.data.data.pkqPaperRecordTwo.pkqPaperTopicList[i].qptAnswerIds || '').split(',').map(Number))
                        }

                    }
                    this.$form("getPkqPaperDetails");
                })
            }
        },
        openLoading() {
            //loading请求等待
            this.loading = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Bulksure() {
            const bulkdata = {
                projectId: this.theProjectId,
                qpId: this.getPkqPaperList_data.qpId,
                qprStatus: this.getPkqPaperList_data.qprStatus,
            };
            this.openLoading();
            var s = qs.stringify(bulkdata);
            var that = this;
            axios({
                method: "post",
                url:
                    that.baseUrl +
                    "/opportunity/question-paper-record/exportQuestionPaperRecordList",
                data: s,
                withCredentials: true,
                timeout: 1200000,
                responseType: "arraybuffer",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    token: A.local("$Usertoken"),
                    projectId: +A.local("$projectId")
                }
            }).then(function (res) {
                if (res.data) {
                    that.loading.close();
                    let a = document.createElement("a");
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", "答题记录.xlsx");
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });
                }
            });
        },
        getList(e) {
            this.getPkqPaperList({ qpId: e })
        },
        getList2(e) {
            this.getPkqPaperList({ qpStatus: e })
        },

        toEditScore(row) {
            this.$form("updateQuestionPaperRecordScore", this.row = row);
        },
        myformQuestionPaperRecordScore(submit, Myformdata) {
            Myformdata.qprId = this.row.questionPaperTopicRecord.qprId;
            Myformdata.qptrId = this.row.questionPaperTopicRecord.qptrId;
            submit();
        },
    },

    created() {
        this.theUserProject = A.local("$projectId");
        if (this.theUserProject == 0) {
            this.getProjectList({
                pageSize: 0
            });
        } else {
            this.theProjectId = this.theUserProject;
        }
        this.getPkqPaperList();
        this.getQuestionPaperList()
    }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/testPaperpkPage/testPaperpk.vue